import React from 'react';
import maleAvatar from '../assets/Avatar_m.svg';
import femaleAvatar from '../assets/Avatar_f.svg';
import neutralAvatar from '../assets/Avatar_n.svg';

interface ProfileAvatarProps {
  avatarType: 'male' | 'female' | 'neutral';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ 
  avatarType, 
  size = 'md', 
  className = '' 
}) => {
  const getAvatarSrc = () => {
    switch (avatarType) {
      case 'male':
        return maleAvatar;
      case 'female':
        return femaleAvatar;
      case 'neutral':
        return neutralAvatar;
      default:
        return neutralAvatar;
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'w-12 h-12';
      case 'md':
        return 'w-14 h-14';
      case 'lg':
        return 'w-16 h-16';
      default:
        return 'w-14 h-14';
    }
  };

  return (
    <div className={`${getSizeClasses()} ${className} rounded-full overflow-hidden flex items-center justify-center bg-white p-3`}>
      <img 
        src={getAvatarSrc()} 
        alt={`${avatarType} avatar`}
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default ProfileAvatar;
